import styled from '@emotion/styled';
import React, { useState } from 'react';

const Button = styled.button`
    outline: none;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 4px 8px;
    /* width: 74px;
    height: 20px; */
    display: flex;
    align-items: center;
    /* Company */

    background: #02B2D9;
    border-radius: 20px;
    .text{
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 12px;
        /* identical to box height, or 100% */

        /* default/shade/white */

        color: #FFFFFF;
    }
`;

const CustomButton = ({name, onClick}) => {
    return (
        <Button onClick={onClick}>
            <span className="text">{name}</span>
        </Button>
    );
}
export default CustomButton;